/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/multiselect/multiselect',['require','core/templates','screens/multiple-choice/multiple-choice'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var templates = require('core/templates');
  var MultipleChoice = require('screens/multiple-choice/multiple-choice');

  /*****************************************************************************************************************///}

  var MultiSelect = MultipleChoice.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    events: {
      'click .submit-btn': 'submitPressed'
    },

    advanceQuestion: false,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      MultipleChoice.prototype.initialize.apply(this, arguments);

      //console.log('MultiSelect::initialize');

      this.questionTmpl = templates['screens/multiselect/question'];
    },

    itemPressed: function(option)
    {
      var selected = option.get('selected');
      option.set('selected', !selected);

      this.question.currentView.render();

      var numSelected = this.question.currentView.collection.where({ selected: true }).length;

      this.$el.find('.submit-btn').toggle((numSelected > 0)); // if at least one selected, show submit button

      return false;
    },

    submitPressed: function(e)
    {
      var options = this.question.currentView.collection;
      var allCorrect = this.checkDone();

      var feedback = this.currentQuestion.get('feedback') || { };

      //console.log(allCorrect);

      this.question.currentView.disable();

      var attemptsRemaining = this.currentQuestion.get('attempts');

      //console.log(attemptsRemaining);

      if (attemptsRemaining > 0)
      {
        this.currentQuestion.set('attempts', attemptsRemaining - 1);

        if (allCorrect)
        {
          this.showFeedback(feedback['correct'], this.setupQuestion);
        }
        else
        {
          if (this.options.remediation === 'recycle') // add question to end
          {
            //console.log('Recycling question into deck');
            this.questions.push(this.currentQuestion);
          }
          else if (this.options.remediation === 'immediate') // insert question in front
          {
            //console.log('Setting question for immediate remediation');
            this.questions.unshift(this.currentQuestion);
          }
          else
          {
            //console.log('Question is discarded');
          }

          this.showFeedback(feedback['incorrect'], this.setupQuestion);
        }

        // reset options, not necessary?
        options.each(function(option)
        {
          option.set('selected', false);
        });
      }
      else
      {
        this.showFeedback(feedback['attempts'], this.setupQuestion);
        this.showAnswer();
      }
    },

    showAnswer: function()
    {
      var options = this.question.currentView.collection;

      options.each(function(option)
      {
        var correct = option.get('correct');
        option.set('selected', correct);
      });

      this.question.currentView.render();
    },

    checkDone: function()
    {
      var options = this.question.currentView.collection;

      var correct = options.every(function(option)
      {
        return (option.get('correct') && option.get('selected') || !option.get('correct') && !option.get('selected'));
      });

      return correct;
    },

    finish: function()
    {
      this.$el.find('.submit-btn').hide();

      MultipleChoice.prototype.finish.apply(this, arguments);
    }

  });

  /*****************************************************************************************************************///}

  return MultiSelect;

});

